import { Injectable } from '@angular/core';
import { addHours, startOfDay } from 'date-fns';
import { DateService } from './date.service'
import { GeneralService } from './general.service';
@Injectable({ providedIn: 'root' })
export class ActionsService
{
    constructor(private generalService : GeneralService, private dateService : DateService){}
    event =
    {
      id : null,
      title: null,
      start: null,
      end: null,
      url : null,
      classNames: null,
      editable	: null,
      startEditable		: null,
      durationEditable		: null,
      backgroundColor		: null,
      borderColor		: null,
      textColor		: null,
    }
    createEvent(actionD,title,id,start ,end ,backgroundColor :string ,textColor : string,url ? : string,editable? : boolean)
    {
      if(editable == undefined)
        editable =false;
      return{
              id : id.toString(),
              title : title,
              start : new Date(start),
              end : new Date(end),
              backgroundColor : backgroundColor,
              textColor : textColor,
              router :url,
              editable : editable,
              actionD : actionD
            };
    }
    setCalendar2(listeActionDTotal, events,listeClients,listeColl,planning)
    {
      var listeCodeListeAction= this.generalService.distinct(listeActionDTotal,"avtAction_Code")
      listeCodeListeAction.forEach((avtAction_Code) =>
      {
        var actionD = listeActionDTotal.find(a =>
        {
          return a.avtAction_Code==avtAction_Code;
        })
        var client = listeClients.find(cli =>
        {
          return cli.Tiers_code==actionD.Tiers_code;
        })
        if(client == undefined)
        {
          client = {Tiers_NomPublic:"",Tiers_code:""}
        }
        var listeActionD = this.getListActionD(listeActionDTotal, avtAction_Code);
        listeActionD.forEach((actionD) =>
        {
          var coll = listeColl.find(col =>
          {
            return col.Perso_Matricule==actionD.Perso_Matricule;
          })
          if(coll == undefined)
          {
            coll = {Perso_Matricule:"",Perso_Nom:""}
          }
          //,actionD.avtActionD_Code
          if (actionD.avtActionD_heureDebAM != null && actionD.avtActionD_heureDebAM != "" && actionD.avtActionD_heureDebAM != "00:00:00.0000000" && actionD.avtActionD_heureDebAM != "00:00" && actionD.avtActionD_heureDebAM != "")
          {
              this.setEvent(events, actionD.avtAction_Intitule +' ('+actionD.avtActionD_Info+')', actionD.avtActionD_date, actionD.avtActionD_heureDebAM, actionD.avtActionD_heureFinAM,actionD.avtActionD_Code,client,avtAction_Code,coll,planning);
          }
          if (actionD.avtActionD_heureDebPM != null && actionD.avtActionD_heureDebPM != "" && actionD.avtActionD_heureDebPM != "00:00:00.0000000" && actionD.avtActionD_heureDebPM != "00:00" && actionD.avtActionD_heureDebPM != "")
          {
              this.setEvent(events, actionD.avtAction_Intitule +' ('+actionD.avtActionD_Info+')', actionD.avtActionD_date, actionD.avtActionD_heureDebPM, actionD.avtActionD_heureFinPM,actionD.avtActionD_Code,client, avtAction_Code,coll,planning);
          }
        });
      });
      return events;
    }
    setCalendar(listeAction, listeActionDTotal, events,listeClients,listeColl,planning)
    {
      listeAction.forEach((action) =>
      {
        var client = listeClients.find(cli =>
        {
          return cli.Tiers_code==action.Tiers_code;
        })
        if(client == undefined)
        {
          client = {Tiers_NomPublic:"",Tiers_code:""}
        }
        var listeActionD = this.getListActionD(listeActionDTotal, action.avtAction_Code);
        listeActionD.forEach((actionD) =>
        {
          var coll = listeColl.find(col =>
          {
            return col.Perso_Matricule==actionD.Perso_Matricule;
          })
          if(coll == undefined)
          {
            coll = {Perso_Matricule:"",Perso_Nom:""}
          }
          //,actionD.avtActionD_Code
          if (actionD.avtActionD_heureDebAM != null && actionD.avtActionD_heureDebAM != "" && actionD.avtActionD_heureDebAM != "00:00:00.0000000" && actionD.avtActionD_heureDebAM != "00:00" && actionD.avtActionD_heureDebAM != "")
          {
              this.setEvent(events, action.avtAction_Intitule +' ('+actionD.avtActionD_Info+')', actionD.avtActionD_date, actionD.avtActionD_heureDebAM, actionD.avtActionD_heureFinAM,actionD.avtActionD_Code,client, action.avtAction_Code,coll,planning);
          }
          if (actionD.avtActionD_heureDebPM != null && actionD.avtActionD_heureDebPM != "" && actionD.avtActionD_heureDebPM != "00:00:00.0000000" && actionD.avtActionD_heureDebPM != "00:00" && actionD.avtActionD_heureDebPM != "")
          {
              this.setEvent(events, action.avtAction_Intitule +' ('+actionD.avtActionD_Info+')', actionD.avtActionD_date, actionD.avtActionD_heureDebPM, actionD.avtActionD_heureFinPM,actionD.avtActionD_Code,client, action.avtAction_Code,coll,planning);
          }
        });
      });
      return events;
    }

    setEvent(events, intitule, date, heureDeb, heureFin,avtActionD_Code,client,avtAction_Code,coll,planning)
    {
      var title =  "";
     
      title = heureDeb.substring(0,5)+" -> "+heureFin.substring(0,5) + " "
      if(planning != "planning_action" && planning != "mon_planning_action")
        title+=  intitule
      if(planning != "client")
        title+= client.Tiers_NomPublic
      if(planning != "coll")
        title+= coll.Perso_Nom
      events.push(
      {
        start: addHours(startOfDay(new Date(date)), this.dateService.setFormaTimeCalendar(heureDeb)),
        end: addHours(startOfDay(new Date(date)), this.dateService.setFormaTimeCalendar(heureFin)),
        title: title,
        description: avtActionD_Code,
        id:avtActionD_Code,
        Tiers_code:client.Tiers_code
          // color: colors.red
      });
      return events;
    }
    getListActionD(listeActionD, avtAction_Code : string)
    {
      var list = listeActionD.filter(function (actionD)
      {
          return  avtAction_Code.localeCompare(actionD.avtAction_Code.toString())===0;
      });
      return list;
    }
    verifierDate(date,periode,ds)
    {
      date = new Date(date);
      var date2=date.getFullYear()+"-"+date.getMonth()+"-"+date.getDate();
      var list = ds.avtactionD.filter(element =>
      {
          var t=element.avtActionD_date.split("-")
          var d = new Date(t[0],t[1]-1,t[2]);
          var d2= d.getFullYear()+"-"+d.getMonth()+"-"+d.getDate();
          return d2 == date2;
      });
      var test  = false;
      list.forEach(element =>
      {
        if(periode=="AM")
        {
          if (element.avtActionD_heureDebPM != null && element.avtActionD_heureDebPM != "00:00:00.0000000"&& element.avtActionD_heureDebPM != "00:00" && element.avtActionD_heureDebPM != "")
          {
            test  =  true;
          }
        }
        else
        {
          if (element.avtActionD_heureDebAM != null && element.avtActionD_heureDebAM != "00:00:00.0000000"&& element.avtActionD_heureDebAM!= "00:00" && element.avtActionD_heureDebAM!= "")
          {
            test  =  true;
          }
        }
      });
      return test;
    }
  //retourne liste action pour une liste actionD ou liste actionD pour une liste action
  getListeActionOrActionD(liste1, liste2)
  {
    var listeAvtAction_Code=";"
    liste2.forEach(actionD =>
    {
      listeAvtAction_Code+=actionD.avtAction_Code+";"
    });
    return liste1.filter(action =>
    {
      var avtAction_Code = ";"+action.avtAction_Code +";";
      return listeAvtAction_Code.indexOf(avtAction_Code)  >=0;
    })
  }
  calculerTimeFromDs(date: Date, ds)
  {
    //heureDeb,heureFin
    var time = 0;
    ds.avtactionD.forEach(element =>
    {
      //var d1 = date.getFullYear()+"/"+date.
      var d1 = this.dateService.setFormatDate(date);
      var d2 = this.dateService.setFormatDate(element.avtActionD_date);
      if (d1 == d2)
      {
        if (element.avtActionD_heureDebAM != null && element.avtActionD_heureDebAM != "00:00:00.0000000" && element.avtActionD_heureDebAM != "00:00" && element.avtActionD_heureDebAM != "") {
          var date1 = new Date("1/1/2000 " + element.avtActionD_heureDebAM);
          var date2 = new Date("1/1/2000 " + element.avtActionD_heureFinAM);
          time += ((date2.getTime() - date1.getTime()) / 1000) / 3600;
        }
        if (element.avtActionD_heureDebPM != null && element.avtActionD_heureDebPM != "00:00:00.0000000" && element.avtActionD_heureDebPM != "00:00" && element.avtActionD_heureDebPM != "") {
          date1 = new Date("1/1/2000 " + element.avtActionD_heureDebPM);
          date2 = new Date("1/1/2000 " + element.avtActionD_heureFinPM);
          time += ((date2.getTime() - date1.getTime()) / 1000) / 3600;
        }
      }

    });

    return time;
  }
  getNbrHeure(listeActionD)
  {
    if(listeActionD.length >0)
    {
      return listeActionD
    .map(d =>
            this.dateService.timeDif(d.avtActionD_heureDebAM,d.avtActionD_heureFinAM)+
            this.dateService.timeDif(d.avtActionD_heureDebPM,d.avtActionD_heureFinPM))
    .reduce((accumulator, currentValue) => accumulator + currentValue);
    }
    else
      return 0;
  }
  getNbrHeur(listeActionD,periode)
  {
    return listeActionD
    .map(d =>
            this.dateService.timeDif(eval("d.avtActionD_heureDeb"+periode),eval("d.avtActionD_heureFin"+periode)))
    .reduce((accumulator, currentValue) => accumulator + currentValue);
  }
  getReferent(avtAction_Code,lstActionD,listeCollaborateur)
  {
    var liste=null;

    var listeActionD = lstActionD.filter(actionD =>
    {
      return actionD.avtAction_Code == avtAction_Code ;
    });
    var listCodeColl=";"
    listeActionD.forEach(actionD =>
    {
      listCodeColl+=actionD.Perso_Matricule+";"
    });
    liste = listeCollaborateur.filter( coll =>
    {
      return listCodeColl.indexOf(";"+coll.Perso_Matricule+";")>=0;
    });
    return liste;
  }
  enableDesableBouton(listWeek,listMonth,listeActionD, propertyDate = "avtActionD_date")
  {
    listWeek.forEach(week =>
    {
      var dateWeekStrat = this.dateService.convertStrToDate(week.monthName);
      var dateWeekEnd = this.dateService.convertStrToDate(week.monthName).setDate(dateWeekStrat.getDate()+6);
      var test = false
      if(listeActionD.length >0)
      {
        listeActionD.forEach(actionD =>
        {
          var dateActionD = new Date(actionD[propertyDate]).getTime();
          if(dateWeekStrat.getTime() <= dateActionD && dateActionD <= dateWeekEnd)
          {
            test = true;
          }
        });
      }
      week.enable = test;
    });
    listMonth.forEach(month =>
    {
      var dateWeekStrat = new Date(month.year,month.monthId,1);
      var dateWeekEnd = new Date(month.year,month.monthId,month.colSpan);
      var test = false
      if(listeActionD.length >0)
      {
        listeActionD.forEach(actionD =>
        {
          var dateActionD = new Date(actionD[propertyDate]).getTime();
          if(dateWeekStrat.getTime() <= dateActionD && dateActionD <= dateWeekEnd.getTime())
          {
            test = true;
          }
        });
      }
      month.enable = test;
    });
  }
  DateDebutInferieurDateFin(MatinChecked,ApMidiChecked,avtAction_heureDebAM,avtAction_heureFinAM,avtAction_heureDebPM,avtAction_heureFinPM)
  {
    var test = true
    if(MatinChecked)
    {
      var timeDebut =new Date("1/1/2000 "+avtAction_heureDebAM).getTime();
      var timeFin =new Date("1/1/2000 "+avtAction_heureFinAM).getTime();
      test = (timeDebut < timeFin);
    }
    if(ApMidiChecked)
    {
      var timeDebut2 =new Date("1/1/2000 "+avtAction_heureDebPM).getTime();
      var timeFin2 =new Date("1/1/2000 "+avtAction_heureFinPM).getTime();
      test = test && (timeDebut2 < timeFin2);
    }
    return test;
  }
  verifIntervalTime(ds,dsCollaborateurChange,MatinChecked,ApMidiChecked,avtAction_heureDebAM,avtAction_heureFinAM,avtAction_heureDebPM,avtAction_heureFinPM,selectedDays,avtActionD_Code)
  {
    var myDs = this.generalService.clone(ds);
    if(dsCollaborateurChange!= null && dsCollaborateurChange!=undefined)
    {
      dsCollaborateurChange.forEach(element =>
      {
        myDs.avtactionD.push(element);
      });
    }

    // modification d'une ligne actionD: pour le cas de modification
    // d'une ligne actionD déja enregister il ne faux pas la tester
    myDs.avtactionD = myDs.avtactionD.filter( myds => {return myds.avtActionD_Code != avtActionD_Code});
    var test = true;
    var timeDebutAM =(avtAction_heureDebAM);
    var timeFinAM =(avtAction_heureFinAM);

    var timeDebutPM =(avtAction_heureDebPM);
    var timeFinPM =(avtAction_heureFinPM);
    selectedDays.forEach(element =>
    {
      var dateSelectedDays =this.dateService.setFormatDate(new Date(element.annee, element.mois-1,element.day));

      myDs.avtactionD.forEach((elementDs)=>
      {
        if (elementDs.avtActionD_date != null)
        {
          var tab = elementDs.avtActionD_date.split("-");
          var d2 = this.dateService.setFormatDate(new Date(tab[0], tab[1] - 1, tab[2]));
          if(d2==dateSelectedDays)
          {
            var avtActionD_heureDebAM = null;
            var avtActionD_heureFinAM = null;
            var avtActionD_heureDebPM = null;
            var avtActionD_heureFinPM = null;
            if (MatinChecked)
            {
              avtActionD_heureDebAM = elementDs.avtActionD_heureDebAM;
              avtActionD_heureFinAM = elementDs.avtActionD_heureFinAM;
              if(this.inclue(avtActionD_heureDebAM,avtActionD_heureFinAM,timeDebutAM,timeFinAM))
              {
                test = false;
              }
            }
            if (ApMidiChecked)
            {
              avtActionD_heureDebPM = elementDs.avtActionD_heureDebPM;
              avtActionD_heureFinPM = elementDs.avtActionD_heureFinPM;
              if(this.inclue(avtActionD_heureDebPM,avtActionD_heureFinPM,timeDebutPM,timeFinPM))
              {
                test = false;
              }
            }
          }
        }
      });

    });
    return test;
  }
  inclue(timeDebutD,timeFinD,timeDebut,timeFin)
  {
    timeDebutD = new Date("1/1/2000 "+timeDebutD).getTime();
    timeFinD = new Date("1/1/2000 "+timeFinD).getTime();
    timeDebut = new Date("1/1/2000 "+timeDebut).getTime();
    timeFin = new Date("1/1/2000 "+timeFin).getTime();

    var test = false;
    if((timeDebut <= timeDebutD && timeFin >= timeDebutD) ||
      (timeDebut <= timeFinD && timeFin >= timeDebutD) ||
      (timeDebut >= timeDebutD && timeDebut <= timeFinD && timeFin >= timeDebutD && timeFin <=timeFinD) )
    {
      test =true;
    }

    return test;
  }
  isValidData(detaild,myDS,dsCollaborateurLocal)
  {
    var am = false;
    var pm = false;
    if(detaild.avtActionD_heureDebPM != null && detaild.avtActionD_heureDebPM != "00:00:00.0000000" && detaild.avtActionD_heureDebPM != "00:00" && detaild.avtActionD_heureDebPM != "")
    {
      pm=true;
    }
    if(detaild.avtActionD_heureDebAM != null && detaild.avtActionD_heureDebAM != "00:00:00.0000000" && detaild.avtActionD_heureDebAM != "00:00" && detaild.avtActionD_heureDebAM != "")
    {
      am=true;
    }
    if(this.DateDebutInferieurDateFin(am,pm,detaild.avtActionD_heureDebAM,detaild.avtActionD_heureFinAM  ,detaild.avtActionD_heureDebPM,detaild.avtActionD_heureFinPM))
    {
      var date = this.dateService.setFormatDateServer(detaild.avtActionD_date);
      var selectedDays =
      [{
        annee: date.getFullYear(),
        day: date.getDate(),
        mois: date.getMonth()+1,
        tooltip: "",
      }];
      if(this.verifIntervalTime(myDS,dsCollaborateurLocal,am,pm,detaild.avtActionD_heureDebAM,detaild.avtActionD_heureFinAM  ,detaild.avtActionD_heureDebPM,detaild.avtActionD_heureFinPM,selectedDays,detaild.avtActionD_Code))
      {
        return true;

      }
      else
      {
        return false;
      }
    }
    else
    {
      return false;
    }
  }
  eventInclueInListeEvent(listeEvent,event, esclureId = true)
  {
    var result = false;
    var condition : boolean;
    listeEvent.forEach(myEvent =>
    {
      if(!esclureId)
        condition = true
      else
        condition = myEvent.id != event.id
      if(condition)
        if(this.dateService.intervaleDateInclueDansIntervaleDate(myEvent.start,  myEvent.end,event.start,event.end  ))
        {
          result = true;
        }
    });
    return result;
  }
  listeEventInclueInListeEvent(listeEvent,listeEventToVerification, esclureId = true) : boolean
  {
    var find = false;
    listeEventToVerification.forEach(event =>
    {
      if(this.eventInclueInListeEvent(listeEvent,event,esclureId))
      find = true;
    });
    return find
  }
 }